import { render } from "./CountermanSeperate.vue?vue&type=template&id=2084a022&scoped=true"
import script from "./CountermanSeperate.vue?vue&type=script&lang=js"
export * from "./CountermanSeperate.vue?vue&type=script&lang=js"

import "./CountermanSeperate.vue?vue&type=style&index=0&id=2084a022&scoped=true&lang=css"

import exportComponent from "/var/www/intercity.dev-jatri.jatritech.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2084a022"]])

export default __exports__